import '../App.css';
import First from '../images/book1.jpeg';
import Second from '../images/book2.jpeg';
import Third from '../images/book3.jpeg';
import Fourth from '../images/book4.jpeg';
import { Link } from 'react-router-dom';

export default function Featured() {

    return (
        <div className='featured-container'>
            <Link className='featured-fourth' to='/products/ftbid4'>
                <img className='featured-fourth-img' src={Fourth} alt='featured'/>
            </Link>
            <Link className='featured-third' to='/products/ftbid3'>
                <img className='featured-third-img' src={Third} alt='featured'/>
            </Link>
            <Link className='featured-second' to='/products/ftbid2'>
                <img className='featured-second-img' src={Second} alt='featured'/>
            </Link>
            <Link className='featured-first' to='/products/ftbid1'>
                <img className='featured-first-img' src={First} alt='featured'/>
            </Link>
        </div>
        
        
    )

}
